import { useEffect, useState } from "react";
import api from "../api";

/** Scheda «Da dove arriva»: percorso, messaggio originale, funnel e risposte del contatto. */
export default function ApptOrigin({ appt, onClose }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [prof, setProf] = useState("");

  const profila = async () => {
    setProf("…");
    try {
      const r = await api.post(`/appointments/${appt.id}/profilazione`);
      setProf(r.data.queued ? "✅ Email pronta in «Da approvare»: leggila e inviala da lì."
        : `Non l'ho preparata: ${r.data.motivo}.`);
    } catch (e) { setProf(`Errore: ${e?.response?.data?.detail || e.message}`); }
  };

  useEffect(() => {
    api.get(`/appointments/${appt.id}/origine`)
      .then((r) => setD(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || e.message));
  }, [appt.id]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 640 }} onClick={(e) => e.stopPropagation()} data-testid="appt-origin-modal">
        <h3 style={{ marginTop: 0 }}>Da dove arriva · {appt.name}</h3>
        {err && <p style={{ color: "#f87171" }}>{err}</p>}
        {!d && !err && <p className="muted">Sto controllando…</p>}
        {d && (
          <>
            <p style={{ fontSize: 15, margin: "0 0 10px" }} data-testid="appt-origin-tipo">
              <strong>{d.tipo}</strong>
            </p>
            {d.fuori_agenda && (
              <div style={{ background: "rgba(245,158,11,.12)", border: "1px solid rgba(245,158,11,.4)", borderRadius: 10, padding: "8px 12px", fontSize: 13.5, marginBottom: 10 }} data-testid="appt-origin-warning">
                ⚠️ L'orario chiesto non è prenotabile: {d.fuori_agenda}.
                {d.alternativa_libera && <> Primo orario libero: <strong>{d.alternativa_libera}</strong>.</>}
              </div>
            )}

            {d.visita && <p style={{ margin: "0 0 10px", fontSize: 13.5 }} data-testid="appt-origin-visit">📣 {d.visita}</p>}
            {d.pagina && <p className="muted" style={{ margin: "0 0 10px", fontSize: 12.5, wordBreak: "break-all" }}>Pagina di prenotazione: {d.pagina}</p>}
            {d.messaggio && (
              <div style={{ marginBottom: 12 }} data-testid="appt-origin-message">
                <div className="muted" style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: 1 }}>
                  {d.messaggio.canale === "whatsapp" ? "Messaggio WhatsApp" : "Email ricevuta"} · {d.messaggio.quando}
                </div>
                <div style={{ fontWeight: 600, margin: "4px 0" }}>{d.messaggio.oggetto || d.messaggio.mittente}</div>
                <div style={{ whiteSpace: "pre-wrap", fontSize: 13.5, maxHeight: 220, overflow: "auto",
                  background: "rgba(148,163,184,.08)", borderRadius: 10, padding: "10px 12px" }}>
                  {d.messaggio.testo || "—"}
                </div>
              </div>
            )}

            {d.funnel ? (
              <div data-testid="appt-origin-funnel">
                <div className="muted" style={{ fontSize: 12, textTransform: "uppercase", letterSpacing: 1 }}>Percorso di arrivo</div>
                <p style={{ margin: "4px 0 8px" }}>
                  <strong>{d.funnel.nome}</strong>
                  {d.funnel.arrivato_il && <span className="muted"> · primo contatto il {d.funnel.arrivato_il}</span>}
                  {d.funnel.email_ricevute > 0 && <span className="muted"> · {d.funnel.email_ricevute} email ricevute</span>}
                </p>
                {d.funnel.pubblicita && <p style={{ margin: "0 0 6px", fontSize: 13.5 }}>📣 Pubblicità: {d.funnel.pubblicita}</p>}
                {d.funnel.pagina && <p style={{ margin: "0 0 6px", fontSize: 12.5 }} className="muted">Pagina: {d.funnel.pagina}</p>}
                {Object.keys(d.funnel.risposte || {}).length > 0 && (
                  <table style={{ marginBottom: 8 }}>
                    <tbody>
                      {Object.entries(d.funnel.risposte).map(([k, v]) => (
                        <tr key={k}><td style={{ width: "42%" }} className="muted">{k}</td><td><strong>{String(v)}</strong></td></tr>
                      ))}
                    </tbody>
                  </table>
                )}
                {(d.funnel.segnali || []).length > 0 && (
                  <p style={{ fontSize: 13.5, margin: 0 }}>✅ {d.funnel.segnali.join(" · ")}</p>
                )}
                <a className="btn sm" href={`/lead/${d.funnel.lead_id}`} style={{ marginTop: 10, display: "inline-block" }} data-testid="appt-origin-lead-link">Apri la scheda del contatto</a>
              </div>
            ) : (
              <p className="muted" data-testid="appt-origin-nofunnel">Non risulta collegato a nessun funnel: non ha compilato i form del sito.</p>
            )}
          </>
        )}
        <div className="toolbar" style={{ marginTop: 16, justifyContent: "space-between" }}>
          <button className="btn" onClick={profila} disabled={prof === "…"} data-testid="appt-profilazione-btn">
            {prof === "…" ? "Preparo…" : "✉️ Prepara le domande di profilazione"}
          </button>
          <button className="btn" onClick={onClose} data-testid="appt-origin-close">Chiudi</button>
        </div>
        {prof && prof !== "…" && <p style={{ fontSize: 13, marginTop: 8 }} data-testid="appt-profilazione-esito">{prof}</p>}
      </div>
    </div>
  );
}
